import { createSyncRunner } from '../platform/sync-runner';
import { adb, AGENDA_TABLE_MAP } from './db';

/**
 * The agenda sync loop — the platform runner bound to this module's own Dexie
 * database, outbox and endpoint. Started alongside (and independently of) the
 * groceries loop when the app is signed in.
 */
export const agendaSync = createSyncRunner({
  endpoint: '/api/v1/agenda/sync',
  db: adb,
  outbox: adb.outbox,
  meta: adb.meta,
  rejections: adb.rejections,
  tables: AGENDA_TABLE_MAP,
  sinceKey: 'agenda_since',
  lastOkKey: 'agenda_last_ok',
});

export const startAgendaSync = () => agendaSync.startLoop();
